/**
 * 产品信息服务
 */

import { reactive } from 'vue'
import type { ProductInfo } from '../../types/product'
import { DEFAULT_PRODUCT_INFO } from '../../types/product'
import { ProductAPI } from '../api/product'
import type { HttpClient } from '../http/HttpClient'

export class ProductService {
  private productAPI: ProductAPI

  constructor(httpClient: HttpClient) {
    this.productAPI = new ProductAPI(httpClient)
  }

  /**
   * 获取产品信息（异步更新，兼容旧版行为）
   */
  getProductInfo(): Promise<ProductInfo> {
    const productInfo = reactive({ ...DEFAULT_PRODUCT_INFO }) as ProductInfo

    return new Promise((resolve) => {
      this.productAPI
        .getProductInfo()
        .then((result) => {
          Object.assign(productInfo, result)
          // 兼容旧版：givePoint 等于 invite_give_points
          productInfo.givePoint = result.invite_give_points ?? productInfo.givePoint
          resolve(productInfo)
        })
        .catch(() => {
          productInfo.givePoint = 0
          resolve(productInfo)
        })
    })
  }

  /**
   * 获取产品信息（同步风格，返回 Promise）
   */
  async getProductInfoSync(): Promise<ProductInfo> {
    const result = await this.productAPI.getProductInfo()
    return {
      ...DEFAULT_PRODUCT_INFO,
      ...result,
      givePoint: result.invite_give_points ?? DEFAULT_PRODUCT_INFO.givePoint
    }
  }
}
